module.exports = __webpack_public_path__ + "img/schnittkante_lichtgrau_ral7035.e326ddd2.jpg";